import React, { useEffect, useRef, useState } from "react";
import { Navigation } from "lucide-react";
import api from "@/lib/api";
import { CATEGORIES } from "@/lib/categories";
import { MapView } from "@/components/MapView";

const NEAR_KM = 10;

function km(a, b) {
  const R = 6371, r = Math.PI / 180;
  const dLat = (b.lat - a.lat) * r, dLng = (b.lng - a.lng) * r;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export default function MapPage() {
  const [cat, setCat] = useState("");
  const [points, setPoints] = useState([]);
  const [me, setMe] = useState(null);
  const [height, setHeight] = useState(400);
  const boxRef = useRef(null);

  useEffect(() => {
    api.get(`/map${cat ? `?category=${cat}` : "?reklame=true"}`).then((r) => setPoints(r.data)).catch(() => {});
  }, [cat]);

  useEffect(() => {
    const fit = () => {
      const top = boxRef.current ? boxRef.current.getBoundingClientRect().top + window.scrollY : 120;
      const nav = document.querySelector("nav.fixed.bottom-0");
      const navH = nav ? nav.getBoundingClientRect().height : 70;
      setHeight(Math.max(260, window.innerHeight - top - navH - 34));
    };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  const near = me ? points.filter((p) => p.lat && p.lng && km(me, p) <= NEAR_KM).length : 0;

  return (
    <div className="gs-fade">
      <div className="px-4 pt-2">
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2">
          <button data-testid="map-filter-all" onClick={() => setCat("")} className={`shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border ${!cat ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200"}`}>Të gjitha</button>
          {CATEGORIES.filter((c) => !c.route).map((c) => (
            <button key={c.key} data-testid={`map-filter-${c.key}`} onClick={() => setCat(cat === c.key ? "" : c.key)} className={`shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border ${cat === c.key ? `${c.solid} text-white border-transparent` : "bg-white text-slate-600 border-slate-200"}`}>{c.label}</button>
          ))}
        </div>
      </div>
      <div className="px-4 relative" ref={boxRef}>
        <MapView points={points} height={height} locate onLocate={setMe} />
        {me && (
          <div data-testid="map-near-count" className="absolute top-3 left-1/2 -translate-x-1/2 z-[500] bg-white/95 backdrop-blur rounded-full shadow-md px-3 py-1.5 text-xs font-semibold text-slate-800 flex items-center gap-1.5">
            <Navigation className="w-3.5 h-3.5 text-blue-600" />
            {near} vende afër teje (≤{NEAR_KM} km)
          </div>
        )}
        <p data-testid="map-points-count" className="text-xs text-slate-400 mt-1.5 text-center">{points.length} vendndodhje · kliko një marker për detaje</p>
      </div>
    </div>
  );
}
